export default __webpack_public_path__ + "node_modules/cakemail-ui-components/lib/dist/images/logos/powered_by_google_default.png";